import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "src/redux/reducers/CombinedReducers";
import { updateAirportOptions } from "src/utils/airportHelper";

/** The time zone of a package's base airport, loading the airport into the store when it is missing. */
export const useBaseTimezone = (baseAirport: string | undefined): string | undefined => {
  const dispatch = useDispatch();
  const airportOptions = useSelector((state: IRootState) => state.structures.airportOptions);

  useEffect(() => {
    if (baseAirport) void updateAirportOptions(baseAirport, airportOptions, dispatch);
  }, [baseAirport, airportOptions, dispatch]);

  return baseAirport ? airportOptions[baseAirport]?.timezoneId : undefined;
};
